import { PageHeader } from '@portals-platform/ui';
import { CertificateForm } from '../components/new-certificate/certificate-form.js';
import { PortalShell } from '../components/portal-shell.js';

export function NewCertificatePage() {
  return (
    <PortalShell activeId="certificates" pageTitle="Create certificate">
      <div className="mx-auto max-w-[1480px] px-8 pb-12 pt-8">
        <PageHeader
          title="Create certificate"
          description="Complete all fields below to see available certificate templates"
        />
        <CertificateForm />
      </div>
    </PortalShell>
  );
}
